// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pieechart[data-v-33b5dbd2]{width:99%}", ""]);
// Exports
module.exports = exports;
